module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div class="phx-portlet-configuration"></div>\r\n<div class="l-panelContainer container-fluid">  \r\n    <div class="phx-portlet-container phx-proto-resizable row">\r\n        <div class="cw-portlet cw-column1 col-6"></div>\r\n        <div class="cw-portlet cw-column2 col-6"></div>\r\n    </div>  \r\n</div>';
}
return __p;
};
